import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpVentures'

export const investorList = (params = '') => Http.get(`/admin/investors${serialize(params)}`)
export const investorCreate = (params = '') => Http.post('/admin/investors', params)
export const investorByID = (params = '') => Http.get(`/admin/investors/${params}`)
export const investorUpdate = (params = '') => Http.put(`/admin/investors/${params.id}`, params)
export const investorDestroy = (params = '') => Http.delete(`/admin/investors/${params.id}`)
